<div class="form-group">
    <label>Evento de Prematch</label>
    <input type="range" class="form-control" min="0" max="100" />
    <label>Evento En Vivo</label>
    <input type="range" class="form-control" min="0" max="100" />
  </div>
  <button class="btn btn-primary" (click)="setLimits()">Guardar</button>
  